export interface RegisterReserveGroupRequest {
  name: string
  nameKana: string
  bibliographies: {
    bibliographyRealId: number
  }[]
}

export function RegisterReserveGroupRequestToJSON(
  value: RegisterReserveGroupRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    name_kana: value.nameKana !== '' ? value.nameKana : undefined,
    bibliographies:
      value.bibliographies.length > 0
        ? value.bibliographies.map(bibliography => {
            return {
              bibliography_real_id:
                bibliography.bibliographyRealId !== 0
                  ? bibliography.bibliographyRealId
                  : undefined
            }
          })
        : undefined
  }
}
